import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const serverURL = process.env.REACT_APP_URL;

// Send OTP
export const vendorSendOTP = createAsyncThunk(
  "vendorAuth/sendOTP",
  async (phoneNumber, thunkAPI) => {
    try {
      const { data } = await axios.post(
        `${serverURL}/api/vendorSignup/sentOTP`,
        {
          phoneNumber,
        }
      );
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

// Verify OTP
export const vendorVerifyOTP = createAsyncThunk(
  "vendorAuth/verifyOTP",
  async ({ phone, otp }, thunkAPI) => {
    try {
      const { data } = await axios.post(
        `${serverURL}/api/vendorSignup/verifyOTP`,
        {
          phoneNumber: phone,
          otp,
        }
      );
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

const vendorAuthSlice = createSlice({
  name: "vendorAuth",
  initialState: {
    phone: localStorage.getItem("vendorPhone") || "",
    isOTPSent: false,
    isOTPVerified: false,
    loading: false,
    error: null,
    doesVendorPartnerExists: false,
    vendorToken: localStorage.getItem("vendorToken") || "",
    vendorId: localStorage.getItem("vendorId") || "",
  },
  reducers: {
    setPhone(state, action) {
      state.phone = action.payload;
      localStorage.setItem("vendorPhone", action.payload);
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setToken(state, action) {
      state.vendorToken = action.payload;
      localStorage.setItem("vendorToken", action.payload);
    },
    setVendorId(state, action) {
      state.vendorId = action.payload;
      localStorage.setItem("vendorId", action.payload);
    },
    logout(state) {
      state.phone = "";
      state.isOTPSent = false;
      state.isOTPVerified = false;
      state.error = null;
      localStorage.removeItem("vendorPhone");
      localStorage.removeItem("vendorToken");
      localStorage.removeItem("vendorId");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(vendorSendOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(vendorSendOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.isOTPSent = true;
        state.doesVendorPartnerExists =
          action.payload?.doesVendorPartnerExists || false;
      })
      .addCase(vendorSendOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(vendorVerifyOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(vendorVerifyOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.isOTPVerified = action.payload?.success;
        state.doesVendorPartnerExists =
          action.payload?.doesVendorPartnerExists || false;

        if (action.payload?.token) {
          localStorage.setItem("vendorToken", action.payload.token);
          state.vendorToken = action.payload.token;
        } else {
          localStorage.removeItem("vendorToken");
          state.vendorToken = "";
        }

        if (action.payload?.data?._id) {
          localStorage.setItem("vendorId", action.payload.data._id);
          state.vendorId = action.payload.data._id;
        } else {
          localStorage.removeItem("vendorId");
          state.vendorId = "";
        }
      })
      .addCase(vendorVerifyOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPhone, logout, setLoading, setToken, setVendorId } =
  vendorAuthSlice.actions;
export default vendorAuthSlice.reducer;
